export default __webpack_public_path__ + "static/aboutCompany2-98c55cb04c681ba6332acd3b98f2f88d.png";